import React from 'react';
import ReactDOM from 'react-dom/client';
import { Routes, Route, Navigate, BrowserRouter as Router } from 'react-router-dom';
import "./index.scss";
import Layout from './siteLayout';
import RequireAuth from './pages/components/requireAuth';
import RequireAuthAdmin from './pages/components/requireAuthAdmin';
import PageHome from './pages/pageHome';
import Page404 from './pages/page404';
import PagePolicies from './pages/pagePolicies';
import AppLayout from './pages/app/appLayout';
import AppMembers from './pages/app/appMembers';
import AppExchange from './pages/app/appExchange';
import AppEmailHistory from './pages/app/appEmailHistory';
import AppMonitoring from './pages/app/appMonitoring';
import AppBilling from './pages/app/appBilling';
import AppProfile from './pages/app/appProfile';
import AppAdminTools from './pages/app/appAdminTools';
import PageBrandGuidelines from './pages/pageBrandGuidelines';
import PageBlog from './pages/pageBlog';
import PageBlogPost from './pages/pageBlogPost';
import AppDomains from './pages/app/appDomains';
import AppEmailRules from './pages/app/appEmailRules';
import AppEmailDelivery from './pages/app/appEmailDelivery';
import * as Sentry from "@sentry/react";
import packageJson from './../package.json';
import PageSignIn from './pages/pageSignIn';
import { AuthProvider } from './pages/components/authProvider';
import AppOverview from './pages/app/appOverview';


const isLocalhost = (window.location.hostname === 'localhost');
Sentry.init({
	dsn: (isLocalhost) ? "" : "https://340ffa7327af33184489a7b61a2b8e75@o4509367945068544.ingest.us.sentry.io/4509367971151872",
	sendDefaultPii: true,
	integrations: isLocalhost
		? []
		: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration(),
		],
	release: packageJson.version,
	environment: import.meta.env.NODE_ENV,
	tracesSampleRate: isLocalhost ? 0 : 1.0,
	attachStacktrace: true,
	replaysSessionSampleRate: isLocalhost ? 0 : 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	replaysOnErrorSampleRate: isLocalhost ? 0 : 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Router future={{ v7_startTransition: true, v7_relativeSplatPath: true, }}>
	<Sentry.ErrorBoundary fallback={
		<div className="alert alert-danger d-flex align-items-center justify-content-center" style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 9999 }}>
			<i className="fa-solid fa-triangle-exclamation me-2" />
			Please retry in a few seconds. If the issue persists, contact support at support@sparklingemail.com.
		</div>} showDialog>
		<AuthProvider>
			{/* == Sitemap ========== */}
			{/* Don't forget to update the sitemap.xml file in the public folder */}
			{/* ===================== */}
			<Layout>
				<Routes>
					{/* == Static Pages ========== */}
					<Route path="/" element={<PageHome />} />
					<Route path="/login" element={<PageSignIn />} />
					<Route path="/sign-in" element={<Navigate to="/login" replace />} />
					<Route path="/sign-up" element={<Navigate to="/login" replace />} />
					<Route path="/sign-out" element={<Navigate to="/login" replace />} />
					<Route path="/signin" element={<Navigate to="/login" replace />} />
					<Route path="/signup" element={<Navigate to="/login" replace />} />
					<Route path="/signout" element={<Navigate to="/login" replace />} />
					<Route path="/brand-guidelines" element={<PageBrandGuidelines />} />
					<Route path="/policies" element={<PagePolicies />} />
					{/* <Route path="/terms" element={<PagePolicies />} />	Important for MS365 (Terms of service) */}
					{/* <Route path="/privacy" element={<PagePolicies />} /> Important for MS365 (Privacy statement) */}
					{/* == Blog Pages ========== */}
					<Route path="/blog" element={<PageBlog />} />
					<Route path="/blog/:slug" element={<PageBlogPost />} />
					{/* == App Pages ========== */}
					<Route path="/app/*" element={
						<RequireAuth>
							<AppLayout>
								<Routes>
									<Route path="/" element={<AppOverview />} />
									<Route path="/profile" element={<AppProfile />} />
									<Route path="/domains" element={<AppDomains />} />
									<Route path="/members" element={<AppMembers />} />
									<Route path="/rules" element={<AppEmailRules />} />
									<Route path="/deliveries" element={<AppEmailDelivery />} />
									<Route path="/history" element={<AppEmailHistory />} />
									<Route path="/billing" element={<AppBilling />} />
									<Route path="/exchange" element={<AppExchange />} />
									<Route path="/monitoring" element={<AppMonitoring />} />
									{/* == Super Admin Pages ========== */}
									<Route path="/admin/*" element={
										<RequireAuthAdmin>
											<Routes>
												<Route path="/" element={<Navigate to="/app/admin/tools" replace />} />
												<Route path="/tools" element={<AppAdminTools />} />
											</Routes>
										</RequireAuthAdmin>
									} />
									<Route path="*" element={<Navigate to="/app" replace />} />
								</Routes>
							</AppLayout>
						</RequireAuth>
					} />
					{/* == Other Pages ========== */}
					<Route path="*" element={<Page404 />} />
				</Routes>
			</Layout>
		</AuthProvider>
	</Sentry.ErrorBoundary>
</Router>);